import React from "react";
import { FaTimes, FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn } from "react-icons/fa";

const ConstructionServicePage = () => {
  return (
    <div className="font-sans">

      {/* Main Content */}

      <div
        className="rts-banner-area relative bg-gray-900 py-16 md:py-20"
        style={{
          backgroundImage: "url('assets/images/banner/ge.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Dark Overlay with opacity */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Global Business Expansion and Development Solutions
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-6">
              Streamlined construction sourcing to delivery
            </p>

            <button className="px-6 py-2 bg-[#00A3A1] hover:bg-teal-600 text-white font-medium rounded-md transition duration-300">
              Request Quote
            </button>
          </div>
        </div>
      </div>


      {/* Service Details */}
      <div className="service-details-area pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto">
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-teal-600 rounded-lg p-8 mb-4">
                <p className="text-lg text-white">
                  Global Business Expansion & Development Solutions
                  Expanding into new markets is a significant step for any construction company. At Omanye, we specialize in delivering end-to-end strategic solutions that enable
                  smooth, scalable, and sustainable global expansion. Whether you're planning to launch
                  operations in a new region or scale your existing footprint, our expertise ensures
                  you're building with confidence.
                </p>
              </div>

              {/* Service Items */}
              <div className="space-y-4">
                {/* Research & Market Entry Strategy */}
                <div className="flex flex-col md:flex-row items-center gap-8 p-6 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all hover:shadow-xl">
                  <div className="md:w-1/2 order-2 md:order-1">
                    <h4 className="title text-2xl font-bold text-[#063970] mb-2 relative pb-3">
                      Research & Market Entry Strategy
                    </h4>
                    <p className="disc text-gray-600 leading-relaxed">
                      It takes more than just ambition to enter a new market; it also need
                      intelligence. To find construction trends, local labour dynamics, regulatory
                      frameworks, and competitive benchmarks, we perform thorough market study.
                      Together, you and our team will develop a go-to-market plan that takes into
                      account local needs, market dynamics, and industry-specific difficulties.
                    </p>
                  </div>
                  <div className="md:w-1/2 order-1 md:order-2 overflow-hidden rounded-lg shadow-md">
                    <img src="../assets/productimages/RMES.jpg"

                      alt="Research & Market Entry Strategy"
                      className="w-full h-64 md:h-80 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                </div>

                {/* Regulatory Guidance and Compliance */}
                <div className="flex flex-col md:flex-row items-center gap-8 p-6 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all hover:shadow-xl">
                  <div className="md:w-1/2">
                    <h4 className="title text-2xl font-bold text-[#063970] mb-2 relative pb-3">

                      Regulatory Guidance and Compliance
                    </h4>
                    <p className="disc text-gray-600 leading-relaxed">
                      One of the most challenging parts of expanding a construction business
                      internationally is navigating foreign rules, permits, zoning laws, and labour
                      codes. We assist you in adhering to regional safety, environmental, and
                      construction standards. Our compliance advisory lowers risk and guarantees that
                      your projects proceed without expensive delays or legal obstacles.
                    </p>
                  </div>
                  <div className="md:w-1/2 overflow-hidden rounded-lg shadow-md">
                    <img
                      src="../assets/productimages/sqc.jpg"
                      alt="Regulatory Guidance and Compliance"
                      className="w-full h-64 md:h-80 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                </div>

                {/* Development of Scalable Projects */}
                <div className="flex flex-col md:flex-row items-center gap-8 p-6 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all hover:shadow-xl">
                  <div className="md:w-1/2 order-2 md:order-1">
                    <h4 className="title text-2xl font-bold text-[#063970] mb-2 relative pb-3">
                      Development of Scalable Projects
                    </h4>
                    <p className="disc text-gray-600 leading-relaxed">
                      Scalability is a key consideration in the design of our development solutions.
                      We assist you in standardising procedures, integrating cutting-edge project
                      management systems, and optimising resource allocation from pre-construction
                      planning to multi-phase execution. This implies more control, uniform quality,
                      and quicker timelines—regardless of location.
                    </p>
                  </div>
                  <div className="md:w-1/2 order-1 md:order-2 overflow-hidden rounded-lg shadow-md">
                    <img
                      src="../assets/productimages/DSP.jpg"
                      alt="Development of Scalable Projects"
                      className="w-full h-64 md:h-80 object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                </div>

                {/* Integration of the Supply Chain and Local Partnerships */}

              </div>

              <div className="relative w-full rounded-xl overflow-hidden">
                {/* Image as background */}
                <div className="absolute inset-0 z-0">
                  <img
                    src="../assets/productimages/isclp.jpg"
                    alt="service background"
                    className="w-full h-full object-cover"
                  />
                  {/* Dark overlay */}
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 p-6 sm:p-10 flex flex-col justify-center min-h-[250px] sm:min-h-[350px]">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                    Ready to work together
                  </h3>
                  <p className="text-white text-sm sm:text-base max-w-2xl">
                    Whether you have a project in mind and you're looking for a reliable construction
                    partner or you're looking to take the next step in your career, we want to hear from you!
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ConstructionServicePage;